<script setup lang="ts">
import DeviceActions from '@/components/DeviceComponents/Actions/DeviceActions.vue'
import DeviceHubCardFooter from '@/components/DeviceComponents/Card/DeviceHubCardFooter.vue'
import DeviceInformations from '@/components/DeviceComponents/components/DeviceInformations.vue'
import DeviceFiltersConfiguration from '@/components/DeviceComponents/Configuration/DeviceFiltersConfiguration.vue'
import CheckpointLinkColumn from '@/components/DeviceComponents/Table/CheckpointLinkColumn.vue'
import EventLinkColumn from '@/components/DeviceComponents/Table/EventLinkColumn.vue'
import { EKeyCategoryValues } from '@/types/enum/KeyCategoryEnum'
import DeviceRentalsHistoryTable from '@/views/DevicesView/components/DeviceRentalsHistoryTable.vue'
import {
    type Columns,
    type DeviceProviderType,
    EProviders
} from '@rfc/rfc-components-library/types'
import { computed, provide } from 'vue'
import { useI18n } from 'vue-i18n'
import ExportDetectionButton from '../Buttons/ExportDetectionButton.vue'
import DeviceCreateFields from '../DeviceComponents/Create/DeviceCreateFields.vue'
import BibColumn from '../DeviceComponents/Table/BibColumn.vue'
import DevicesFilters from '../DeviceComponents/Table/Filters/DevicesFilters.vue'
import WithdrawalColumn from '../DeviceComponents/Table/WithdrawalColumn.vue'

const { t } = useI18n()

const columnsBefore = computed<Columns[]>(() => [
    { value: 'bib', title: t('detection.model.bib') },
    { value: 'event_name', title: t('detection.model.eventName') },
    { value: 'checkpoint_name', title: t('detection.model.checkpointName') }
])

const columnsAfter = computed<Columns[]>(() => [
    { value: 'withdrawal', title: t('detection.model.withdrawal') },
    { value: 'event_filter', title: t('detection.model.eventFilter') },
    { value: 'timer_filter', title: t('detection.model.timerFilter') }
])

provide<DeviceProviderType>(EProviders.DEVICE, {
    DeviceCardFooter: DeviceHubCardFooter,
    /* DeviceCardFullContent: (value?: Partial<DeviceModel>) =>
        value?.rental?.renter?.organization_id ===
        store.value?.state.authentication.me?.organization_id
            ? DeviceRentalDateInformations
            : undefined, */

    ExportDetectionsComponent: ExportDetectionButton,
    DeviceInformations: DeviceInformations,
    DeviceActions: DeviceActions,
    DeviceDetectionsColumns: {
        columnsBefore,
        columnsAfter,
        components: [
            {
                name: 'bib',
                component: BibColumn
            },
            {
                name: 'event_name',
                component: EventLinkColumn
            },
            {
                name: 'checkpoint_name',
                component: CheckpointLinkColumn
            },
            {
                name: 'withdrawal',
                component: WithdrawalColumn
            }
        ]
    },
    DeviceCreateFields: DeviceCreateFields,
    DeviceConfiguration: DeviceFiltersConfiguration,
    DeviceInformationsTabSections: DeviceRentalsHistoryTable,
    ConfigurationKeys: EKeyCategoryValues,

    deviceTableFilters: DevicesFilters
})
</script>

<template>
    <slot />
</template>
